import withAemIntegration from "../../withAemIntegration";
//import Component from '@lexus.com/ui/dist/components/ContextComponent';

const ContextModuleEditConfig = {
  emptyLabel: "ContextModule",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const ContextModule = (props) => (
  //<Component {...props} />
  <div></div>
);

export default withAemIntegration("lexus/components/context-module")(
  ContextModule,
  ContextModuleEditConfig
);
